import C3Chart from 'react-c3js';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import Loading from '../../Common/Loading';

const getColumns = (stages, timeSeries, tasks) => {
  console.log('stages', stages);
  const intervals = _.keys(_.values(timeSeries)[0]).sort();
  const x = _.flatten(['x', intervals.map((i) => moment(i).format('YYYY-MM-DD HH:mm'))]);
  const data = _.mapValues(timeSeries, (values, stageId) => {
    let cumulative = 0;
    return _.flatten([stages.find((s) => s.id === stageId).name, intervals.map((i) => {
      cumulative += (values[i] || 0);
      return cumulative;
    })])
  });

  const total = _.flatten(['Total', intervals.map(() => tasks.length)]);

  const result = _.values(data);
  result.unshift(x, total);
  console.log('result', result);
  return result;
}

const generateTimeSeriesChart = (stages, timeSeries, tasks) => {
  return {
    data: {
      x: 'x',
      xFormat: '%Y-%m-%d %H:%M', // 'xFormat' can be used as custom format of 'x'
      columns: getColumns(stages, timeSeries, tasks),
    },
    axis: {
      x: {
        type: 'timeseries',
        tick: {
          // format: '%m/%d %H:%M',
          format: (x) => {
            return moment(x).format('MMM D, h:mm a');
          },
        },
      },
      y: {
        min: 0,
        padding: { bottom: 0 }
      },
    },
  };
};

const TimeSeriesChart = ({ job, timeSeries, tasks = [] }) => {
  if (!job || !timeSeries) {
    return (<Loading/>);
  }

  console.log('timeSeries', timeSeries);

  if (timeSeries.length === 0) {
    return (<div>No Data</div>);
  }

//   const intervals = [];
//   const stages = [];
//   const data2 = null;
//   const tasks = null;
//   // const jobProgressTimeSeriesChart = null;
//   // const intervals = null;
//
//   const dateFormat = 'YYYY-MM-DD HH:mm';
//
//   const cumulativeColumns = [_.flatten(['x', intervals.map((i) => i.format(dateFormat))])];
//   stages.forEach((stage) => {
//     let total = 0;
//     cumulativeColumns.push(_.flatten([stage.name, intervals.map((i) => {
//       // console.log('data2[stage.id]', data2[stage.id]);
//       total += data2[stage.id] ? data2[stage.id][i.toISOString()] || 0 : 0;
//       return total;
//     })]));
//   });
//   cumulativeColumns.push(_.flatten(['Expected Tasks', _.range(intervals.length).map(() => tasks.length)]));
//   console.log('cumulativeColumns', cumulativeColumns);
//
//   const absoluteColumns = [_.flatten(['x', intervals.map((i) => i.format(dateFormat))])];
//   stages.forEach((stage) => {
//     absoluteColumns.push(_.flatten([stage.name, intervals.map((i) => data2[stage.id] ? data2[stage.id][i.toISOString()] || 0 : 0)]));
//   });
//   console.log('absoluteColumns', absoluteColumns);
//
//   // return {
//   //   data2,
//   //   absolute: generateTimeSeriesChart(absoluteColumns),
//   //   cumulative: generateTimeSeriesChart(cumulativeColumns),
//   // };
//
//   var data = {
//     x: 'x',
// //        xFormat: '%Y%m%d', // 'xFormat' can be used as custom format of 'x'
//     columns: [
//       ['x', '2013-01-01', '2013-01-02', '2013-01-03', '2013-01-04', '2013-01-05', '2013-01-06'],
// //            ['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
//       ['data1', 30, 200, 100, 400, 150, 250],
//       ['data2', 130, 340, 200, 500, 250, 350]
//     ]
//   };
//   const axis = {
//     x: {
//       type: 'timeseries',
//       tick: {
//         format: '%Y-%m-%d'
//       }
//     }
//   };

  const chart = generateTimeSeriesChart(job.profile.stages, timeSeries, tasks);

  // console.log('data2', data2);
  return (<C3Chart
    data={chart.data}
    axis={chart.axis}
  />);
};

TimeSeriesChart.propTypes = {
  job: PropTypes.object,
};

export default TimeSeriesChart;


// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/TimeSeriesChart.js